module.exports = __webpack_public_path__ + "img/glacier-point-1.f802629d.jpg";